import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { SyntheticEvent } from 'react'
import styled, { css } from 'styled-components'

import { mobileMenuButtonLinkStyles } from './styles/mobile-menu'

export interface RightArrowProps {
  className?: string
  isOpen?: boolean
}

const RightArrow: React.FC<RightArrowProps> = ({ className }) => (
  <FontAwesomeIcon className={className} icon={faChevronDown} />
)

const StyledRightArrow = styled(RightArrow)<{ $isAccountPage?: boolean }>`
  color: ${({ $isAccountPage, theme }) =>
    $isAccountPage ? theme.colors.grayscale.black : theme.colors.grayscale.white};
  transition: 0.3s transform ease-in-out;
  float: right;
  margin-top: 0.25rem;
  margin-right: 0.375rem;
  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(-180deg);
    `};

  @media (min-width: 768px) {
    margin-right: 0.5rem;
  }
`

export interface MenuAccordionToggleProps {
  isActive?: boolean
  onToggle?: (e?: SyntheticEvent) => void
}

const MenuAccordionToggle: React.FC<
  React.HTMLAttributes<HTMLDivElement> &
    MenuAccordionToggleProps & {
      rightArrow?: React.ComponentType<RightArrowProps>
    }
> = ({ children, className, isActive, onToggle, rightArrow = StyledRightArrow }) => {
  return (
    <button className={className} onClick={onToggle}>
      {children}
      {React.createElement(rightArrow, { isOpen: isActive })}
    </button>
  )
}

const StyledMenuAccordionToggle = styled(MenuAccordionToggle)<{ $isAccountPage?: boolean }>(
  ({ $isAccountPage, theme }) => ({
    ...mobileMenuButtonLinkStyles,
    width: '100%',
    color: $isAccountPage ? theme.colors.brand.blue : theme.colors.grayscale.white,
    [`${StyledRightArrow}`]: {
      color: $isAccountPage ? theme.colors.brand.blue : theme.colors.grayscale.white,
    },
  }),
)

export { StyledMenuAccordionToggle as MenuAccordionToggle }
